/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from "react";
import { INewsDisplay } from "api/types/NewsEntity";
import { apiFilter } from "api/new/filterApi";

import MarkerMap from "./MarkerMap";

import { IQuery } from "../Menus/QueryMenu/QueryMenu";

interface EventsMapProps {
  query: IQuery;
}
const IframeEventsMap: React.FC<EventsMapProps> = ({ query }) => {
  const [events, setEvents] = useState<INewsDisplay[]>([]);

  useEffect(() => {
    const getData = async () => {
      const data = await apiFilter({ ...query, limit: 150 });
      setEvents(data.items);
    };
    getData();
  }, [events, query]);

  return (
    <div>
      <MarkerMap events={events} />
    </div>
  );
};

export default IframeEventsMap;
